const MINUTE = 60;
const HOUR = 60 * MINUTE;

const TOKEN_TTL_SECONDS = {
  refresh: 10 * HOUR,
  register: 24 * HOUR,
  reset: 10 * MINUTE
};

module.exports = {TOKEN_TTL_SECONDS};
